import type { IWarehouseRepository } from '../../domain/interfaces';
import type { UpdateWarehouseDTO } from '../dtos/warehouse/UpdateWarehouseDTO';
import type { WarehouseResponseDTO } from '../dtos/warehouse/WarehouseResponseDTO';

export interface UpdateWarehouseUseCase {
  execute(id: string, dto: UpdateWarehouseDTO): Promise<WarehouseResponseDTO>;
}

export default class UpdateWarehouseUseCaseImpl implements UpdateWarehouseUseCase {
  constructor(
    private readonly warehouseRepository: IWarehouseRepository
  ) {}

  async execute(id: string, dto: UpdateWarehouseDTO): Promise<WarehouseResponseDTO> {
    const warehouse = await this.warehouseRepository.findById(id);
    if (!warehouse) {
      throw new Error(`Warehouse not found: ${id}`);
    }

    if (dto.name !== undefined) {
      warehouse.updateName(dto.name);
    }

    if (dto.status === 'ACTIVE') {
      warehouse.activate();
    } else if (dto.status === 'INACTIVE') {
      warehouse.deactivate();
    }

    await this.warehouseRepository.save(warehouse);

    return {
      id: warehouse._id,
      name: warehouse.name,
      status: warehouse.status,
      createdAt: warehouse.createdAt,
      updatedAt: warehouse.updatedAt,
    };
  }
}
